import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import MapOutlinedIcon from '@mui/icons-material/MapOutlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import MenuIcon from '@mui/icons-material/Menu';
import KeyIcon from '@mui/icons-material/Key';
import FeedbackIcon from '@mui/icons-material/Feedback';
import HelpIcon from '@mui/icons-material/Help';
import InfoIcon from '@mui/icons-material/Info';
import RecentActorsIcon from '@mui/icons-material/RecentActors';
import DatasetIcon from '@mui/icons-material/Dataset';
import { AuthProvider, getAccessTokenCookie } from '../Login/AuthProvider';
import { ROUTE_PATHS } from 'src/routes';
import { NavLink, useHistory } from "react-router-dom";
import './MobileMenu.scss';
import { useStoreContext } from '../../store/context';
import { useOpenCalc, useUser, useUserTokens } from '../../store/actions';
import HikingIcon from '@mui/icons-material/Hiking';
import TableChartIcon from '@mui/icons-material/TableChart';
import { useEffect } from 'react';
import { checkUserFieldSampleCollector, fieldSampleAreaEditor, genUser } from 'src/store/common';
import Divider from '@mui/material/Divider';
import { removeUser } from '../Login/RefreshAuth';
import AssessmentIcon from '@mui/icons-material/Assessment';
import CalculateIcon from '@mui/icons-material/Calculate';
type Anchor = 'top' | 'left' | 'bottom' | 'right';

export default function MobileMenu() {
  const [state, dispatch] = useStoreContext();
  const setUser = useUser(dispatch);
  const setUserTokens = useUserTokens(dispatch);
  const setOpenCalc = useOpenCalc(dispatch);
  const history = useHistory();
  const [stateOfMenu, setStateOfMenu] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const handleLogOut = () =>{
    removeUser(setUser, setUserTokens);
    if(window.location.pathname.includes('/inap')
    || window.location.pathname.includes(`${ROUTE_PATHS.data_import}`)
    || window.location.pathname.includes(`${ROUTE_PATHS.contacts}`)
    || window.location.pathname.includes(`${ROUTE_PATHS.sample}`)
    || window.location.pathname.includes(`${ROUTE_PATHS.group}`)
    || window.location.pathname.includes(`${ROUTE_PATHS.area}`)
    || window.location.pathname.includes(`${ROUTE_PATHS.field_sample_sites}`)
      || window.location.pathname.includes(`${ROUTE_PATHS.field_samples}`)
    ){
      history.push(`${ROUTE_PATHS.home}`)
      window.location.reload()
    }
    else{
      window.location.reload();
    }  
  };

  const toggleDrawer =
    (anchor: Anchor, open: boolean) =>
    (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event.type === 'keydown' &&
        ((event as React.KeyboardEvent).key === 'Tab' ||
          (event as React.KeyboardEvent).key === 'Shift')
      ) {
        return;
      }

      setStateOfMenu({ ...stateOfMenu, [anchor]: open });
  };

    useEffect(()=>{
      if(localStorage.getItem('user') && getAccessTokenCookie('refreshToken')){
        const parsedSession = JSON.parse(localStorage.getItem('user')??'')
        setUser(parsedSession.userInfo)
      }
    },[setUser]);
    
  const list = (anchor: Anchor) => (
    <Box
      sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 250, overflowX: 'hidden' }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List>

        <ListItem disablePadding>
          <ListItemButton component={NavLink} to={"/"} className ='linkStyles' style={{marginLeft: '1rem'}}>
            <ListItemIcon>
              <MapOutlinedIcon />
            </ListItemIcon>
            <ListItemText primary="Maps" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton component={NavLink} to={ROUTE_PATHS.download} className ='linkStyles' style={{ marginLeft: '1rem'}}>
            <ListItemIcon>
              <DownloadOutlinedIcon />
            </ListItemIcon>
            <ListItemText primary="Download" />
          </ListItemButton>
        </ListItem>
        {
          state.user?.appRoles ?
          (
            (
              checkUserFieldSampleCollector(state.user) 
            )
            &&
            (
              <ListItem disablePadding>
                <ListItemButton component={NavLink} to={ROUTE_PATHS.field_samples} className='linkStyles' style={{ marginLeft: '1rem'}}>
                  <ListItemIcon>
                    <HikingIcon />
                  </ListItemIcon>
                  <ListItemText primary="Field Sample" />
                </ListItemButton>
              </ListItem>
            )
          )
          :
          (
            null
          )
        }
        <ListItem disablePadding style ={{marginLeft: '1rem'}}>
          <ListItemButton component={NavLink} to={ROUTE_PATHS.table} className ='linkStyles'>
            <ListItemIcon>
              <TableChartIcon />
            </ListItemIcon>
            <ListItemText primary="Tables" />
          </ListItemButton>
        </ListItem>

        <ListItem disablePadding style ={{ marginLeft: '1rem', marginBottom: '1rem',}}>
          <ListItemButton component={NavLink} to={ROUTE_PATHS.powerbi} className ='linkStyles'>
            <ListItemIcon>
              <AssessmentIcon />
            </ListItemIcon>
            <ListItemText primary="Reports" />
          </ListItemButton>
        </ListItem>
        <Divider style={{marginBottom: '1rem'}}/>
        {
          state.user?.appRoles ? 
          (
            (
              genUser(state.user)
            )
            &&
            (
              <div>
                <ListItem disablePadding>
                  <ListItemButton component={NavLink} to={ROUTE_PATHS.contacts} className='linkStyles' style={{marginLeft: '1rem'}}>
                    <ListItemIcon>
                      <RecentActorsIcon />
                    </ListItemIcon>
                    <ListItemText primary="Contacts" />
                  </ListItemButton>
                </ListItem>
              </div>
            )
          ): (null) 
        }
        {
          state.user?.appRoles ? 
          (
            (
              fieldSampleAreaEditor(state.user)
            )
            &&
            (
              <div>
                <ListItem disablePadding >
                <ListItemButton component={NavLink} to={`${ROUTE_PATHS.data_process}${ROUTE_PATHS.data_import}`} className='linkStyles' style={{ marginLeft: '1rem'}}>
                  <ListItemIcon>
                    <DatasetIcon />
                  </ListItemIcon>
                    <ListItemText primary="Data Process" />
                  </ListItemButton>
                </ListItem>
              </div>
            )
          ): (null) 
        }


        <ListItem disablePadding>
          <ListItemButton component={NavLink} to={ROUTE_PATHS.help} target="_blank" rel="noopener noreferrer" className ='linkStyles' style={{ marginLeft: '1rem'}}>
            <ListItemIcon>
              <HelpIcon />
            </ListItemIcon>
            <ListItemText primary="Help" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton component={NavLink} to={ROUTE_PATHS.about} target="_blank" rel="noopener noreferrer" className ='linkStyles' style={{ marginLeft: '1rem'}}>
            <ListItemIcon>
              <InfoIcon />
            </ListItemIcon>
            <ListItemText primary="About" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton href="https://forms.office.com/Pages/ResponsePage.aspx?id=4F2CSwVwPUuaFHhBHyhmA4pqM7aQ1oBHuyBVp6-LTzZUQThWWU9OUjVPODFMVk9USTVYUkZORk1QSSQlQCN0PWcu" target='_blank' className ='linkStyles' style={{ marginLeft: '1rem'}}>
            <ListItemIcon>
              <FeedbackIcon />
            </ListItemIcon>
            <ListItemText primary="Feedback" />
          </ListItemButton>
        </ListItem>

        <ListItem disablePadding>
          <ListItemButton onClick={()=>setOpenCalc(true)} className ='linkStyles' style={{marginLeft: '1rem'}}>
            <ListItemIcon>
              <CalculateIcon />
            </ListItemIcon>
            <ListItemText primary="Fire Danger Calculator" />
          </ListItemButton>
        </ListItem>

        <ListItem disablePadding>
          <ListItemButton component={NavLink} to={ROUTE_PATHS.apiKey} className ='linkStyles' style={{marginLeft: '1rem'}}>
            <ListItemIcon>
              <KeyIcon />
            </ListItemIcon>
            <ListItemText primary="API Key" />
          </ListItemButton>
        </ListItem>
        { state.user?.appRoles?
            (
            <ListItem disablePadding style={{paddingLeft: '1rem'}}>
              <ListItemButton onClick={handleLogOut}>
                <ListItemIcon>
                  <LogoutOutlinedIcon />
                </ListItemIcon>
                <ListItemText primary="Log Out" />
              </ListItemButton>
            </ListItem>
          )
          :(!state.user && <ListItem style={{paddingLeft:'2rem', textTransform: 'capitalize'}}><AuthProvider/></ListItem>)
        }
      </List>
    </Box>
  );

  return (
    <div style={{display:'inline'}}>
      {(['right'] as const).map((anchor) => (
        <React.Fragment key={anchor}>
          <Button aria-label='Hamburger button to view all the pages of fems available' onClick={toggleDrawer(anchor, true)}><MenuIcon/></Button>
          <Drawer
            anchor={anchor}
            open={stateOfMenu[anchor]}
            onClose={toggleDrawer(anchor, false)}
          >
            {list(anchor)}
          </Drawer>
        </React.Fragment>
      ))}
    </div>
  );
}